export const videoStates = {
    invisible: 'INVISIBLE',
    sleeping: 'SLEEPING',
    wokeUpFromSleep: 'WOKE_UP_FROM_SLEEP',
    awake: 'AWAKE',
}

export const audioStates = {
    panting: 'spotPant',
    bark: 'spotBark'
}